export default __webpack_public_path__ + "static/media/number2.58cf6fd1.png";